export interface IYearPlanningWindow {
  id?: string;
  year?: number;
  planYear?: number | string;
  planningStartFrom?: string | null;
  planningEndAt?: string | null;
  revisionStartFrom?: string | null;
  revisionEndAt?: string | null;
}

export const defaultValue: Readonly<IYearPlanningWindow> = {};
